import React from "react";
import locale from './locale.json';
import { start_new_conversation, messageCall, eventsCall } from "./ChatbotQueries";
import MyTextInput from "./components/MyTextInput";
import MyList from "./MyList";
import { messagesStored, storeItem, getValueFromSessionStored } from "./Session";

const BOT_TIME = process.env.REACT_APP_BOT_TIME;
const INACTIVITY_TIME = 90000; // in miliseconds

function getTimeStamp() {
  var d = new Date();
  var h = d.getHours().toString();
  var m = d.getMinutes().toString();
  var s = d.getSeconds().toString();
  var day = d.getUTCDate().toString()
  var month = (d.getUTCMonth() + 1).toString()
  var year = d.getUTCFullYear().toString()

  if (h < 10) { h = "0" + h }
  if (m < 10) { m = "0" + m }
  if (s < 10) { s = "0" + s }
  if (day < 10) { day = "0" + day }
  if (month < 10) { month = "0" + month }
  return day + "/" + month + "/" + year + " - " + h + ":" + m + ":" + s
}

function getRandomUser() {
  let nameCookie = Date.now() * Math.random() * Math.pow(2, 32) + 1;
  let finalCookie = nameCookie.toString(36).replace("0.", "");
  return finalCookie;
}

function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

class MyChatList extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.key = this.state.messages.length;
    this.user = getValueFromSessionStored("user_id");
    this.conversation_id = "";
    this.conversation_token = "";
    this.primera_vez = getValueFromSessionStored("primera_vez") !== null ? getValueFromSessionStored("primera_vez") : true;
    this.handleStart();
    this.warning_long_msg = getValueFromSessionStored("wrng_lngmsg", false)
  }

  getInitialState() {
    let msgs = messagesStored();
    for (let i = 0; i < msgs.length; i++) {
      if (!msgs[i].reproduced) { msgs[i].reproduced = true; }
    }
    let fixedState = {
      messages: msgs,
      text: "",
      scroll: false,
      uploader: false,
      files: [],
      disableInput: false,
      is_writing: false
    }
    return { ...fixedState }
  }

  async handleStart() {
    let intentos = 0;
    if (!this.conversation_id || !this.conversation_token) {
      this.conversation_id = getValueFromSessionStored("conversation_id")
      this.conversation_token = getValueFromSessionStored("conversation_token")
    }

    while (!this.conversation_id && intentos < 3) {
      await this.init_conversation()
      intentos++;
    }
    if (!this.user) {
      this.user = getRandomUser()
      storeItem("user_id", this.user)
    }
    if (this.state.messages.length === 0) {
      this.props.is_writing(true);
      this.switchState(true);
      let welcome_messages = [{
        data: [],
        answer: locale["es"].welcome.text,
        type: "text",
      },
      {
        data: locale["es"].welcome.data,
        answer: "",
        type: "postback_button",
      }]

      this.handleResponse(welcome_messages);

      let response = await eventsCall(
        "send_welcome_message",
        this.user,
        this.conversation_id,
        this.conversation_token
      );
      if (!response[0].answer.startsWith("Hola, soy el asistente virtual")) {
        this.handleResponse(response);
      }
    }
  }

  async init_conversation() {
    let { conversationId, conversation_token } = await start_new_conversation()
    this.conversation_id = conversationId
    this.conversation_token = conversation_token
    storeItem("conversation_id", this.conversation_id)
    storeItem("conversation_token", this.conversation_token)
  }

  switchState(state) {
    this.setState({
      is_writing: state,
    });
  }

  handleOnSendMessage(msg) {
    this.setState({
      text: "",
      uploader: false,
    });
    if (parseInt(msg) >= 1 && parseInt(msg) <= 5 && this.state.messages.at(-1) && this.state.messages.at(-1).type === "rating") {
      this.send_rating(parseInt(msg))
      let last_rating_msg = this.state.messages.at(-1)
      last_rating_msg.rating = parseInt(msg)
    } else {
      let message = {
        text: msg,
        type: "text",
        isUser: true,
        key: this.key++,
        date: getTimeStamp(),
        reproduced: false
      };
      this.sendMessage(message);
      this.primera_vez = false;
      storeItem("primera_vez", false);
      this.chatbotBackendQuery(message.text, this.props.selected_language);

      clearInterval(this.interval)
      this.interval = setTimeout(() => {
        this.send_inactivity()

      }, INACTIVITY_TIME)
    }
  }

  handleOnSendMessagePayload(msg) {
    this.setState({
      text: "",
      uploader: false,
    });
    let message = {
      text: msg.text,
      type: "text",
      isUser: true,
      key: this.key++,
      date: getTimeStamp(),
      reproduced: false,
    };
    this.sendMessage(message);
    this.primera_vez = false;
    storeItem("primera_vez", false);
    this.chatbotBackendQuery(msg.payload, this.props.selected_language);
    clearInterval(this.interval)
    this.interval = setTimeout(() => {
      this.send_inactivity()

    }, INACTIVITY_TIME)
  }


  async handleOnSendEventMessage(msg) {

    this.setState({
      text: ""
    });
    let message = {
      text: msg.text,
      type: "text",
      isUser: true,
      key: this.key++,
      date: getTimeStamp(),
      reproduced: false
    };
    this.sendMessage(message);
    let response = await eventsCall(
      { event_id: "get_answer", user_id: this.user, data: { "payload": msg.payload } },
      this.props.selected_language
    );
    this.handleResponse(response);
  }

  async chatbotBackendQuery(message, language) {
    // if (message.length > 200) {
    //   console.log("message")
    //   let message_hardcode = [{
    //     "data": [],
    //     "answer": "¿Esto es muy largo no?",
    //     "type": "text",
    //   }]
    //   this.handleResponse(message_hardcode);
    // } else {
    this.props.is_writing(true);
    this.switchState(true);
    let { response, status } = await messageCall(message, this.user, this.conversation_id, this.conversation_token);
    this.handleResponse(response);
    if (status === 403) { // la sesion ha caducado
      this.retry_connect()
      // }
    }
  }

  async retry_connect() {
    this.props.is_writing(true);
    this.switchState(true);
    await this.init_conversation()
    let response = await eventsCall(
      "send_welcome_message",
      this.user,
      this.conversation_id,
      this.conversation_token
    );
    this.primera_vez = true;
    storeItem("primera_vez", true);
    this.handleResponse(response);
  }

  async send_rating(newRating, index) {
    this.props.is_writing(true);
    this.switchState(true);
    let last_rating_msg = this.state.messages.at(index)
    last_rating_msg.rating = parseInt(newRating)
    let response = await eventsCall(
      "valoracion",
      this.user,
      this.conversation_id,
      this.conversation_token,
      newRating
    );
    this.handleResponse(response);

    let message = {
      text: "",
      type: "rated",
      rating: newRating,
      isUser: true,
      key: this.key++,
      date: getTimeStamp(),
      reproduced: false
    };
    this.sendMessage(message);
    //this.chatbotBackendQuery(newRating, this.props.selected_language);
  }

  async send_inactivity() {
    let response = await eventsCall(
      "inactivity",
      this.user,
      this.conversation_id,
      this.conversation_token,
    );
    this.handleResponse(response);
  }

  async send_too_long_warning() {
    let response = await eventsCall(
      "long_message",
      this.user,
      this.conversation_id,
      this.conversation_token,
    );
  }

  async handleResponse(response) {

    let send_message = true
    for (var msg = 0; msg < response.length; msg++) {
      let message_back = {
        text: response[msg].answer,
        type: response[msg].type,
        data: response[msg].data,
        isUser: false,
        key: this.key++,
        date: getTimeStamp(),
        reproduced: false,
      };

      let time;

      if (BOT_TIME) {
        time = BOT_TIME;
      } else if (this.primera_vez) {
        time = 0
      } else if (msg === 0) { //si es el primero, rapido
        time = 500;
      } else { //si no es el primero
        let words_number = response[msg - 1].answer.split(" ")
        time = words_number.length * 60;
      }

      if (message_back.type === "disambiguationIBM") {
        this.setState({ disableInput: true });
      } else {
        this.setState({ disableInput: false });
      }

      if (send_message) {
        this.props.is_writing(true);
        this.switchState(true);

        await timeout(time);
        this.sendMessage(message_back);

        this.props.is_writing(false);
        this.switchState(false);
        storeItem("appState", this.state);
        if (message_back.text.startsWith("Puedes presentar una queja")) {
          window.location.href = "https://portal-sac.defensordelpueblo.es/es/form/queja"
          this.minimize()
        }
      }
    }
  }

  sendMessage(message) {
    let m = this.state.messages;
    m = m.concat([message]);

    this.setState({ messages: m });
    this.props.is_writing(false);
  }

  async onDisambiguationIBMButtonClick(response) {
    let clickResponse = await eventsCall(
      {
        event_id: "disambiguation_click",
        user_id: this.user,
        data: { response: response },
      },
      this.props.selected_language
    );
    this.handleResponse(clickResponse);
  }

  scrollToBottom = () => {
    this.setState({ scroll: true });
  };

  onChange = (value) => {
    if (value.length >= 200 && !getValueFromSessionStored("wrng_lngmsg", false)) {
      let message_hardcode = [{
        "answer": "",
        "data": [{ "text": locale["es"].warning_long_msg }],
        "type": "warning",
      }]
      this.handleResponse(message_hardcode);
      storeItem("wrng_lngmsg", true)
      this.send_too_long_warning()
    }
    this.setState({ text: value });
  };
  
  minimize = () => {
    this.props.minimize();
  }

  render() {
    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexFlow: "column",
          minHeight: "0",
        }}
      >
        <MyList
          messages={this.state.messages}
          onButtonClick={this.handleOnSendMessage.bind(this)}
          onPostbackButtonClick={this.handleOnSendMessagePayload.bind(this)}
          scroll={this.state.scroll}
          onDisambiguationIBMButtonClick={this.onDisambiguationIBMButtonClick.bind(
            this
          )}
          eventButtonClick={(m) => this.handleOnSendEventMessage(m)}
          is_writing={this.state.is_writing}
          primera_vez={this.primera_vez}
          send_rating={this.send_rating.bind(this)}
          minimize={this.minimize}
        />
        {!this.primera_vez ?
          <MyTextInput
            title="formulario enviar mensaje"
            aria-label="formulario enviar mensaje"
            style={{
              height: "auto",
              display: "block",
              position: "absolute",
              bottom: "1em",
            }}
            disable={this.state.disableInput}
            onSend={this.handleOnSendMessage.bind(this)}
            scroll={this.scrollToBottom}
            text={this.state.text}
            onChange={this.onChange}
            uploader={this.state.uploader}
            selected_language={this.props.selected_language}
            messages={this.state.messages}
          />
          : null}
      </div>
    );
  }
}

export default MyChatList;
export { getTimeStamp };
